import { styled } from '@mui/styles';
import { Alert as MUIAlert, Button } from '@mui/material';

export const Alert = styled(MUIAlert)({
  mb: 2,
  fontSize: '16px',
  '& .MuiAlert-message': {
    gap: '16px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  '& .MuiAlert-icon': {
    display: 'flex',
    alignItems: 'center'
  }
});

export const AlertButton = styled(Button)({
  minWidth: '190px'
});
